import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, Validators, ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import {
    MCCustomIdNumValidators,
    //MCCustomeIdNumValidators,
    MCCustomPhoneValidators,
    MCRegex
} from '@maslul/common-services';
import { TooltipModule } from 'primeng/tooltip';
import {
    // MCRadioButtonGroup,
    MCFormFieldWrapperComponent,
    MCCityStreetListsComponent,
    MCInputTextComponent,
    McInfoComponent,
    MCRadioButtonGroup,
    MCAccessibilityLabelDirective
} from '@maslul/common-components';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { ApplicantDetails } from '../../../../../../models/applicant/applicant-details';
import { ValidationMessageData } from '../../../../../../resources/validation-massage';
import { TranslateService } from '@ngx-translate/core';
import { RequestApprovalTypeDetailsStore } from '../../../../../../services/store/approval-type-details-store';
import { ApprovalTypeData } from '../../../../../../services/approval-type/approvals-type-data';



@Component({
    selector: 'mi-applicant-details-fields',
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TooltipModule,
        MCFormFieldWrapperComponent,
        MCInputTextComponent,
        MCRadioButtonGroup,
        MCCityStreetListsComponent,
        McInfoComponent,
        MCAccessibilityLabelDirective
    ],
    templateUrl: './applicant-details-fields.html',
    styleUrl: './applicant-details-fields.scss',
    encapsulation: ViewEncapsulation.None
})
export class ApplicantDetailsFieldsComponent implements OnInit {

    @Input() applicant: ApplicantDetails | undefined;

    applicantDetailsForm!: FormGroup;
    private subscriptions: Subscription = new Subscription();
    showPackageNumberField: boolean = false;
    showIsYoursRadio: boolean = true;
    public customErrorMessages = ValidationMessageData.customErrorMessages

    applicantText: any;

    constructor(
        private translateService: TranslateService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore

    ) { }

    ngOnInit(): void {
        this.initText();
        this.initForm();
        this.initSubscriptions();
    }

    initText() {
        this.subscriptions.add(this.translateService.stream('applicantDetails').subscribe(translation => {
            this.applicantText = translation;
        }));
    }

    initForm() {
        this.applicantDetailsForm = new FormGroup({
            userId: new FormControl(this.applicant?.userId, [Validators.required, MCCustomIdNumValidators.idNum()]),
            firstName: new FormControl(this.applicant?.firstName, [Validators.required, Validators.pattern(MCRegex.freeText), Validators.maxLength(25)]),
            lastName: new FormControl(this.applicant?.lastName, [Validators.required, Validators.pattern(MCRegex.freeText), Validators.maxLength(25)]),
            mobile: new FormControl(this.applicant?.communicationDetails?.mobile, [Validators.required, MCCustomPhoneValidators.mobile()]),
            email: new FormControl(this.applicant?.communicationDetails?.email, [Validators.required, Validators.pattern(MCRegex.mail), Validators.maxLength(50)]),
            city: new FormControl(this.applicant?.address?.city, { validators: [Validators.required], updateOn: 'change' }),
            street: new FormControl(this.applicant?.address?.street, { validators: [Validators.required], updateOn: 'change' }),
            homeNumber: new FormControl(this.applicant?.address?.homeNumber, [Validators.required, Validators.pattern(MCRegex.homeNumber), Validators.maxLength(6)]),
            postalCode: new FormControl(this.applicant?.address?.postalCode, [Validators.pattern(MCRegex.postalCode), Validators.maxLength(7)]),
            isPackageYours: new FormControl(this.applicant?.isPackageYours, { updateOn: 'change' }),
            packageOwnerGroup: new FormGroup({
                packageOwnerId: new FormControl(this.applicant?.packageOwnerId, [MCCustomIdNumValidators.idNum()]),
                packageOwnerFirstName: new FormControl(this.applicant?.packageOwnerFirstName, [Validators.pattern(MCRegex.freeText), Validators.maxLength(25)]),
                packageOwnerLastName: new FormControl(this.applicant?.packageOwnerLastName, [Validators.pattern(MCRegex.freeText), Validators.maxLength(25)]),
                packageOwnerMobile: new FormControl(this.applicant?.packageOwnerCommunicationDetails?.mobile, [MCCustomPhoneValidators.mobile()]),
                packageOwnerEmail: new FormControl(this.applicant?.packageOwnerCommunicationDetails?.email, [Validators.pattern(MCRegex.mail), Validators.maxLength(50)])
            }),

        });
        this.viewIsPackageYours();
        this.viewPackageOwner(this.applicant?.isPackageYours);

    }

    get isInvalidAndTouchedUserId(): boolean {
        const control: FormControl = this.getFormControl('userId');
        return (control?.invalid && (control?.touched || control?.dirty)) || false;
    }

    get isInvalidAndTouchedPackageOwnerId(): boolean {
        const packageOwnerGroup = this.applicantDetailsForm.get('packageOwnerGroup') as FormGroup;

        const control: FormControl = packageOwnerGroup.get('packageOwnerId') as FormControl;
        return (control?.invalid && (control?.touched || control?.dirty)) || false;
    }

    getFormControl(key: string): FormControl {
        const control = this.applicantDetailsForm.get(key);
        if (control instanceof FormControl) {
            return control;
        }
        throw new Error(`קונטרול עם מפתח '${key}' אינו FormControl או אינו קיים.`);
    }

    getFormGroup(key: string): FormGroup {
        const control = this.applicantDetailsForm.get(key);
        if (control instanceof FormGroup) {
            return control;
        }
        throw new Error(`קונטרול עם מפתח '${key}' אינו FormControl או אינו קיים.`);
    }

    viewIsPackageYours() {
        const isPackageYoursControl = this.applicantDetailsForm.get('isPackageYours');
        const currentApprovalTypeId: string = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        if (ApprovalTypeData.isPackageYoursFieldDisplay.includes(+currentApprovalTypeId)) {
            this.showIsYoursRadio = false;
            isPackageYoursControl?.setValue('yes');
        }
        else {
            isPackageYoursControl?.addValidators(Validators.required)
        }
    }

    viewPackageOwner(isPackageYours: string | undefined) {
        const packageOwnerGroup = this.applicantDetailsForm.get('packageOwnerGroup') as FormGroup;
        if (isPackageYours === 'no') {
            this.showPackageNumberField = true;
            packageOwnerGroup.enable();
            packageOwnerGroup.get('packageOwnerId')!.addValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerFirstName')!.addValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerLastName')!.addValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerMobile')!.addValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerEmail')!.addValidators(Validators.required);


        } else {
            this.showPackageNumberField = false;
            packageOwnerGroup.disable();
            packageOwnerGroup.reset();
            packageOwnerGroup.get('packageOwnerId')!.removeValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerFirstName')!.removeValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerLastName')!.removeValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerMobile')!.removeValidators(Validators.required);
            packageOwnerGroup.get('packageOwnerEmail')!.removeValidators(Validators.required);
        }
    }

    initSubscriptions() {
        this.subscriptions.add(
            this.applicantDetailsForm.get('isPackageYours')!.valueChanges
                .pipe(distinctUntilChanged())
                .subscribe(isPackageYours => {
                    this.viewPackageOwner(isPackageYours);
                })
        );
    }

    public isFormValid(): boolean {
        this.applicantDetailsForm.updateValueAndValidity();
        return this.applicantDetailsForm.valid;
    }
}
